import { formatKitQuantity } from "@/lib/formatKitQuantity";

/** Short alternates suffix for configuration queue row metadata (matches remaining · date line). */
export function configurationQueueInventoryAlternateSuffix(count: number): string | null {
  if (!Number.isFinite(count) || count <= 0) {
    return null;
  }
  if (count === 1) {
    return "1 alternate";
  }
  return `${formatKitQuantity(count)} alternates`;
}

export function configurationQueueRowRemainingLine(
  remainingToBuild: number,
  mfrShipByDateLabel: string,
  inventoryAlternatesOnHand: number,
): string {
  const base = `${formatKitQuantity(remainingToBuild)} remaining · ${mfrShipByDateLabel}`;
  const alternates = configurationQueueInventoryAlternateSuffix(inventoryAlternatesOnHand);
  return alternates == null ? base : `${base} · ${alternates}`;
}
